module.exports = {
          srcSet: "/_next/static/images/user5-146-05f8dd0e5ec44e635a6c83823beef1f8.jpg"+" 146w",
          images:[ {path: "/_next/static/images/user5-146-05f8dd0e5ec44e635a6c83823beef1f8.jpg",width: 146,height: 146}],
          src: "/_next/static/images/user5-146-05f8dd0e5ec44e635a6c83823beef1f8.jpg",
          toString:function(){return "/_next/static/images/user5-146-05f8dd0e5ec44e635a6c83823beef1f8.jpg"},
          
          width: 146,
          height: 146
        }